<!-- FILE: src/views/ReportsPage.vue -->
<template>
  <div class="container my-5">
        <!-- Page Header -->
        <!-- <header class="d-flex align-items-center pb-3 mb-4 border-bottom">
            <a href="#" class="d-flex align-items-center text-dark text-decoration-none">
                <i class="fas fa-chart-bar fa-2x me-3 text-success"></i>
                <span class="fs-4">تقارير مسابقة تارجت لحفظ القرآن الكريم</span>
            </a>
        </header> -->

        <!-- Loading and Error State -->
        <!-- <div v-if="isLoading" class="text-center my-5">
            <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">جاري تحميل التقارير...</p>
        </div>

        <div v-if="error" class="alert alert-danger">
            حدث خطأ أثناء تحميل البيانات: {{ error }}
        </div> -->

        <!-- Main Content -->
        <div v-if="!isLoading && !error">
            <!-- Stats Dashboard -->
            <div class="row mb-4 g-4">
                <div class="col-lg-3 col-md-6">
                    <div class="card text-white bg-success shadow-sm stats-card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h3 class="fw-bold">{{ stats.total_participants || 0 }}</h3>
                                    <span>إجمالي المشتركين</span>
                                </div>
                                <i class="fas fa-users"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card text-white bg-primary shadow-sm stats-card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h3 class="fw-bold">{{ stats.male_count || 0 }}</h3>
                                    <span>عدد الذكور</span>
                                </div>
                                <i class="fas fa-male"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card text-white bg-danger shadow-sm stats-card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h3 class="fw-bold">{{ stats.female_count || 0 }}</h3>
                                    <span>عدد الإناث</span>
                                </div>
                                <i class="fas fa-female"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card bg-warning shadow-sm stats-card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h3 class="fw-bold">{{ stats.region_count || 0 }}</h3>
                                    <span>عدد المناطق</span>
                                </div>
                                <i class="fas fa-map-location-dot"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Levels Summary -->
            <div class="card mb-4">
                <div class="card-header bg-light">
                    <i class="fas fa-layer-group me-2"></i><strong>توزيع المشتركين حسب المستوى</strong>
                </div>
                <div class="card-body">
                    <ul class="list-group list-group-flush">
                        <li v-for="(name, key) in levelNames" :key="key" class="list-group-item d-flex justify-content-between align-items-center">
                          
                            {{ name }}
                            <span class="badge bg-success rounded-pill">{{ getLevelCount(key) }} مشترك ({{ getLevelPercentage(key) }}%)</span>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Participants Table -->
            <div class="card shadow-sm">
                <div class="card-header bg-light">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0"><i class="fas fa-table me-2"></i>قائمة المشتركين</h5>
                        <div class="w-50">
                            <input type="text" v-model="searchTerm" class="form-control" placeholder="ابحث بالاسم، الرقم القومي، الهاتف...">
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-hover">
                            <thead class="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>اسم المشترك</th>
                                    <th>الرقم القومي</th>
                                    <th>رقم الهاتف</th>
                                    <th>المنطقة</th>
                                    <th>مستوى المسابقة</th>
                                    <th>النوع</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="filteredContestants.length === 0">
                                    <td colspan="7" class="text-center">لا توجد نتائج مطابقة للبحث.</td>
                                </tr>
                                <tr v-for="(contestant, index) in filteredContestants" :key="contestant.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ contestant.name }}</td>
                                    <td>{{ contestant.national_id }}</td>
                                    <td>{{ contestant.phone }}</td>
                                    <td>{{ contestant.address_region }}</td>
                                    <td>{{ levelNames[contestant.subscription_type] || 'غير محدد' }}</td>
                                    <td>{{ contestant.gender }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../api/axios';

export default {
    name: 'ReportsPage',
    data() {
        return {
            isLoading: true,
            error: null,
            contestants: [],
            stats: {},
            searchTerm: '',
            levelNames: {
                level1: "المستوى الأول (القرآن كاملاً)",
                level2: "المستوى الثاني (نصف القرآن)",
                level3: "المستوى الثالث (10 أجزاء)",
               
            },
        };
    },
    computed: {
        filteredContestants() {
            if (!this.searchTerm) {
                return this.contestants;
            }
            const term = this.searchTerm.toLowerCase().trim();
            return this.contestants.filter(p => 
                (p.name && p.name.toLowerCase().includes(term)) ||
                (p.national_id && p.national_id.includes(term)) ||
                (p.phone && p.phone.includes(term))
            );
        }
    },
    methods: {
        async fetchReportData() {
            this.isLoading = true;
            this.error = null;
            try {
                const response = await api.get('/reports/summary');
                this.contestants = response.data.contestants;
                this.stats = response.data.stats;
            } catch (err) {
                this.error = 'فشل في تحميل البيانات من الخادم.';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        getLevelCount(levelKey) {
            return this.stats.level_summary ? (this.stats.level_summary[levelKey] || 0) : 0;
        },
        getLevelPercentage(levelKey) {
            const levelCount = this.getLevelCount(levelKey);
            const total = this.stats.total_participants || 0;
            if (total === 0) return '0.0';
            return ((levelCount / total) * 100).toFixed(1);
        }
    },
    created() {
        this.fetchReportData();
    }
};
</script>

<style scoped>
    /* يمكنك استيراد ملفات CSS خارجية أو وضع التنسيقات هنا مباشرة */
    .stats-card i {
        font-size: 2.5rem;
        opacity: 0.3;
        position: absolute;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
    }
    .stats-card .card-body {
        position: relative;
        z-index: 1;
    }
    .table-hover tbody tr:hover {
        background-color: #e9f5ea;
    }
    /* .container-fluid {
        max-width: 1400px;
        margin: auto;
    } */
    .nav-link {
  color: #0d6efd;
}

.nav-link.active {
  color: #000;
  font-weight: bold;
}

.fs-1 {
  font-size: 4rem !important;
}
</style>